import {getCookie} from '@optimaxdev/utils';

import {CATEGORY, ONETRUST_COOKIE} from 'constants/analytics';
import {OneTrustCategoryType} from 'types/types';

export type CategoryTypesKeysType = keyof OneTrustCategoryType;

/**
 * Getting active categories based on cookies from OneTrust
 * @returns {Array<string>} - List of categories
 */
export const getOneTrustActiveGroups = (): string[] => {
    const cookieValue = (getCookie(ONETRUST_COOKIE) || 'C0001:1,C0003:1,C0002:1,C0004:1').match(
        /C000\d:\d/g,
    ) || ['C0001:1', 'C0003:1', 'C0002:1', 'C0004:1'];

    return cookieValue.reduce((acc: string[], currentGroup: string) => {
        if (Number(currentGroup.slice(-1)) === 1) return [...acc, currentGroup.slice(0, -2)];
        return acc;
    }, []);
};

/**
 * Checks if the given group of cookies is in the list of active cookies in oneTrust
 * @param {CategoryTypesKeysType} groupName - Name of cookie group
 * @returns {boolean} - Result
 */
export const isGroupActive = (groupName: CategoryTypesKeysType): boolean => {
    if (__NODEJS__) return false;
    return Boolean(getOneTrustActiveGroups().find(item => item === groupName));
};

/**
 * Waiting for activation of a group of cookies with the name
 * @param {CategoryTypesKeysType} name - Cookies group name
 */
export function waitForActivatingCookieGroup(name: CategoryTypesKeysType) {
    return new Promise<void>(resolve => {
        if (__NODEJS__ || isGroupActive(name)) {
            resolve();
        } else {
            const listener = () => {
                resolve();
                window.removeEventListener(CATEGORY[name], listener);
            };
            window.addEventListener(CATEGORY[name], listener);
        }
    });
}
